import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnDetailService } from 'tnx-admin-service/columndetail/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
@Component({
    selector: 'columndetail',
    templateUrl: './columndetail.component.html',
    styleUrls: ['./columndetail.component.scss'],
    providers: [ComponentContextService],
})
export class ColumnDetailComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _columnDetailService: ColumnDetailService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._columnDetailService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'idTableInfo', dataType: 'int', name: 'Id của bảng', fullName: 'Id của bảng', description: 'Id của bảng' }),
            new ModelSchema({ field: 'ten', name: 'Tên cột', fullName: 'Tên cột', description: 'Tên cột' }),
            new ModelSchema({ field: 'tenDayDu', name: 'Tên đầy đủ của cột', fullName: 'Tên đầy đủ của cột', description: 'Tên đầy đủ của cột' }),
            new ModelSchema({ field: 'moTa', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'kieuDuLieu', dataType: 'int', name: 'Kiểu dữ liệu', fullName: 'Kiểu dữ liệu', description: 'Kiểu dữ liệu' }),
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'idTableInfo' }),
            new ColumnSchemaBase({ field: 'ten' }),
            new ColumnSchemaBase({ field: 'tenDayDu' }),
            new ColumnSchemaBase({ field: 'moTa' }),
            new ColumnSchemaBase({ field: 'kieuDuLieu' }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'currentStateCode' })
        ];

        super.ngOnInit();
    }
}

